import React from "react";

import { Container } from "@mui/material";
import { Navigate } from "react-router-dom";

import { LoadingSpinner } from "src/components";
import { ROUTE_PATH } from "src/constants";
import useGetFirstPublicSeries from "src/hooks/apis/useGetFirstPublicSeries";

const RootRedirect = () => {
  const { data, error } = useGetFirstPublicSeries();

  if (data) {
    const { slug } = data;
    return <Navigate to={`/series/${slug}/${ROUTE_PATH.AUTH}`} />;
  }

  if (error) {
    return <Navigate to="/404" />;
  }

  return (
    <Container
      maxWidth="lg"
      sx={{
        py             : "50px",
        minHeight      : "100vh",
        display        : "flex",
        flexDirection  : "column",
        alignItems     : "center",
        justifyContent : "center",
      }}
    >
      <LoadingSpinner />
    </Container>
  );
};

export default RootRedirect;
